import { FileVersionModel } from '../../../../typings/api/skymap/rest/v0/.common';
import {
  FileModel,
  FileVersionModel as FileVersionModelV1,
} from '../../../../typings/api/skymap/rest/v1/.common';

/**
 * Returns a new list of file versions sorted by createdAt ASC.
 * @param versions List of file versions.
 */
export const sortFileVersions = (versions: (FileVersionModel | FileVersionModelV1)[]) => {
  return [...versions].sort((a, b) =>
    new Date(a.createdAt).getTime() < new Date(b.createdAt).getTime() ? -1 : 1,
  );
};

export const sortFileVersionsByRevisionDateAndName = (versions: FileVersionModel[]) => {
  return [...versions].sort((left: FileVersionModel, right: FileVersionModel) => {
    const leftRevision = left.revision ? left.revision : '';
    const rightRevision = right.revision ? right.revision : '';
    const lengthComparison = rightRevision.length - leftRevision.length;
    if (lengthComparison !== 0) {
      return lengthComparison;
    }
    const lexicographicalComparison = leftRevision.localeCompare(rightRevision);
    if (lexicographicalComparison === 0) {
      return getVersionNumber(versions, right.id) - getVersionNumber(versions, left.id);
    } else {
      return -lexicographicalComparison;
    }
  });
};

/**
 * Sorts file versions by createdAt ASC and returns the version number for the specified
 * file version ID.
 * @param versions List of file versions.
 * @param fileVersionId ID of file version to find number for.
 */
export const getVersionNumber = (
  versions: (FileVersionModel | FileVersionModelV1)[],
  fileVersionId: string,
) => {
  const sortedVersions = sortFileVersions(versions);
  return sortedVersions.findIndex((v) => v.id === fileVersionId) + 1;
};

/**
 * Returns last version for specified file.
 * @param file File to find last version for.
 */
export const findLastFileVersion = (file: FileModel) => {
  return sortFileVersions(file.versions).at(-1) as FileVersionModelV1;
};
